module.exports = __webpack_public_path__ + "img/hotel-25.3bdb9589.jpeg";